import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiListItemText(_theme: Theme): MuiThemeComponentOverride<"MuiListItemText"> {
  return { MuiListItemText: { styleOverrides: { root: { marginBottom: 0, marginTop: 0 } } } };
}
